<template>
  <td>
    <div>{{ formatSchedule(appointmentData.schedule) }}</div>
  </td>
  <td>
    <div>{{ appointmentData.vet_name }}</div>
  </td>
  <td>
    <div>{{ appointmentData.customer_name }}</div>
  </td>
  <td>
    <div>{{ appointmentData.pet_name }}</div>
  </td>
  <td v-if="considerInsurance">
    <div>{{ appointmentData.pet_policy }}</div>
  </td>
  <td>
    <div>{{ appointmentData.price }}</div>
  </td>
  <td>
    <div>{{ appointmentData.appointment_status }}</div>
  </td>
  <td>
    <div>{{ appointmentData.status_date }}</div>
  </td>
  <td>
    <div class="is-flex is-justify-content-start" style="gap: 1em;">
      <button 
        type="button" 
        class="button is-warning is-small"
        :class="{ 'is-loading': detailsLoading }"
        :disabled="detailsLoading"
        @click="iniAppointmentData(appointmentData)"
      >
        {{ $t('General.Details') }}
      </button>
    </div>
  </td>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue';
import { mapActions, mapGetters } from 'vuex';

export default defineComponent({
  name: 'MngAppointmentRecordTableRow',
  props: {
    appointmentData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      detailsLoading: false
    };
  },
  computed: {
    ...mapGetters(['getAccessType']),
    
    considerInsurance(): boolean {
      return process.env.VUE_APP_CONSIDER_INSURANCE === 'true';
    }
  },
  methods: {
    ...mapActions([
      'iniEditedAppointment',
      'resetAppointmentFiles',
      'iniEditedAppointmentFiles',
      'toggleAppointmentDetailing',
      'toggleShowingAppointmentData'
    ]),

    formatSchedule(schedule: string): string {
      const parts = schedule.split(' ');
      const timeParts = parts[1].split(':');
      return parts[0] + ' ' + timeParts[0] + ':' + timeParts[1];
    },

    async iniAppointmentData(showAppointmentData: any) {
      this.detailsLoading = true;
      try {
        await this.iniEditedAppointment(showAppointmentData.appointment_id);
        await this.resetAppointmentFiles();
        
        
        var filesStatus = 'TK_Active';
        if(this.getAccessType == 'manager')
        {
          filesStatus = 'All';
        }
        await this.iniEditedAppointmentFiles({appointmentId: showAppointmentData.appointment_id,
                                              language: this.$i18n.locale,
                                              status: filesStatus});
        await this.toggleAppointmentDetailing(false);
        await this.toggleShowingAppointmentData(false);
      } finally {
        this.detailsLoading = false;
      }
    }
  }
});
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>
